import React from 'react';
import PropTypes from 'prop-types';
import {CloseIcon} from "../common/Icon";
import {CloseButtonWrapper} from "./styled.jsx";

export const CloseButton = ({className = null, onClick = undefined, ...rest}) => {
  return (
      <CloseButtonWrapper {...rest}
                          className={className}
                          role="button"
                          onClick={onClick}
                          onKeyDown={onClick}>
          <CloseIcon/>
      </CloseButtonWrapper>
  );
};

CloseButton.propTypes = {
  /**
  * What className to use
  */
  className: PropTypes.string,
  /**
  * Optional click handler
  */
  onClick: PropTypes.func,
};

